import { useEffect } from "react";
import { useAtom } from "jotai";
import { appSettingAtom } from "../atoms/appSettingAtom.js";
import { backendGet } from "@accredo/fe-shared/services/dataService.js";
import { useSnackbar } from "notistack";

export function useClaimStates() {
  const [appSettings, setAppSettings] = useAtom(appSettingAtom);
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    const claimStates = appSettings.claimStates;
    if (!claimStates || !Array.isArray(claimStates.states) || claimStates.states.length === 0) {

      backendGet("/data/schadens/states", {
        label: "Schaden-Status",
        enqueueSnackbar,
        setResult: (res) =>
          setAppSettings((prev) => ({
            ...prev,
            claimStates: res.data,
          })),
      });
    }
  }, [appSettings.claimStates, enqueueSnackbar, setAppSettings]);

  return appSettings.claimStates;
}
